export default "__VITE_ASSET__sY61_kwv__"